module.exports = __webpack_public_path__ + "static/media/equidad.f7a8f708.png";